/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ConsentContextOutAction } from './consentContextOutAction';
import type { ConsentContextOutState } from './consentContextOutState';

export interface ConsentContextOut {
  org_name: string;
  employer_name: string | null;
  meeting_at_iso: string;
  meeting_tz: string;
  action: ConsentContextOutAction;
  state: ConsentContextOutState;
  disclosure_text?: string;
  language: string;
}
